import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc DrugPricingDrugSearch defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DrugPricingDrugSearchService } from 'services/drugPricingDrugSearch';
 *
 * // create service instance and send/cancel request
 * const drugPricingDrugSearchService = new DrugPricingDrugSearchService();
 * const result = await drugPricingDrugSearchService.fetchData( '<user-id>' ); // fetch data
 * drugPricingDrugSearchService.cancel(); // cancel an active request
 */
export class DrugPricingDrugSearchService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    searchQuery: get( response, 'body.component.data.state.searchQuery', '' ),
                    fields: get( response, 'body.component.structure.fields', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
